import React, { FunctionComponent, useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { Vat } from "../../models/Market";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store";
import { thunkFetchCurrentMarket } from "../../store/markets/actions";

interface VatSelectProps extends Omit<SelectProps, "loading"> {
  label?: string;
  onSelected?: (value: Vat) => void;
  variant?: "filled" | "outlined" | "standard";
  value?: number;
  error?: boolean;
}

export const VatSelect: FunctionComponent<VatSelectProps> = ({
  label = "Vat",
  onSelected,
  onChange,
  variant = "standard",
  value = [],
  error = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const vats =
    useSelector<AppState, ReadonlyArray<Vat>>(s => s.currentMarket.vats) || [];
  const [state, setState] = useState<ReadonlyArray<Vat>>([]);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      let vat = state.find(p => p.decimalForm === event.target.value);

      if (vat) {
        onSelected(vat);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  useEffect(() => {
    // load if not loaded
    if (!vats || !vats.length) {
      dispatch(thunkFetchCurrentMarket());
    }
  }, []);

  useEffect(() => {
    return setState(
      [...vats].sort((a, b) => (a.percentage > b.percentage ? 1 : -1))
    );
  }, [vats]);

  return (
    <FormControl
      variant={variant}
      className={props.className}
      error={error}
      style={props.style}
    >
      <InputLabel
        id="cluster-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        labelId="Vat-select-label"
        id="Vat-select"
        autoWidth={true}
      >
        {state &&
          state.length > 0 &&
          state.map(p => (
            <MenuItem key={p.decimalForm} value={p.decimalForm}>
              {p.percentage}%
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
